import DeviceManager from '../utils/device-manager';
import Swiper from 'swiper';

export default function initSliderCardsWithIcon() : void {
    const $sliderCardsContainers = document.querySelectorAll<HTMLElement>('.js-slider-cards-container');

    $sliderCardsContainers.forEach($container => {
        new SliderCardsWithIcon($container);
    });
}

export class SliderCardsWithIcon {
    $container: HTMLElement;
    swiper: Swiper;

    constructor($container: HTMLElement) {
        this.$container = $container;

        const swiperParams = {
            loop: true,
            loopAdditionalSlides: 2,
            spaceBetween: 20,
            threshold: 10,
            navigation: {
                nextEl: '.slider-cards-button-next',
                prevEl: '.slider-cards-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            breakpoints: {},
        };
        swiperParams.breakpoints[DeviceManager.devices.md] = {
            spaceBetween: 30,
        };

        this.swiper = new Swiper(this.$container, swiperParams);
    }
}
